import React, {useCallback} from 'react';

import {SideFrameMethodsEnum, SideFrameUIMessageModel} from '../../../../models/frames/sideFrameMessageModel';
import {useSideFrameAlert} from './sideFrameAlert';
import {useSideFrameConfirm} from './sideFrameConfirm';
import {useSideFrameFuzzyList} from './sideFrameFuzzyList';
import {useSideFramePrompt} from './sideFramePrompt';
import {useSideFramePromptDate} from './sideFramePromptDate';
import {useSideFrameReport} from './sideFrameReport';

export type SideFrameDialogDoneHandler = (value?: unknown) => void;
export interface SideFrameDialogDefinition {
  onDone: SideFrameDialogDoneHandler;
}

export function useSideFrameDialogs() {
  const {alert, setAlertData} = useSideFrameAlert();
  const {confirm, setConfirmData} = useSideFrameConfirm();
  const {fuzzyList, setFuzzyListData} = useSideFrameFuzzyList();
  const {prompt, setPromptData} = useSideFramePrompt();
  const {promptDate, setPromptDateData} = useSideFramePromptDate();
  const {report, setReportData} = useSideFrameReport();

  const dialogs = (
    <>
      {alert}
      {confirm}
      {fuzzyList}
      {prompt}
      {promptDate}
      {report}
    </>
  );

  const onUIMessage = useCallback(
    (sideFrameMessage: SideFrameUIMessageModel, onDone: SideFrameDialogDoneHandler) => {
      switch (sideFrameMessage.type) {
        case SideFrameMethodsEnum.ALERT:
          setAlertData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        case SideFrameMethodsEnum.CONFIRM:
          setConfirmData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        case SideFrameMethodsEnum.FUZZYLIST:
          setFuzzyListData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        case SideFrameMethodsEnum.PROMPT:
          setPromptData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        case SideFrameMethodsEnum.PROMPT_DATE:
          setPromptDateData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        case SideFrameMethodsEnum.REPORT:
          setReportData({
            ...sideFrameMessage,
            onDone,
          });
          return;

        default:
          throw new Error('This should not happen.');
      }
    },
    [setAlertData, setConfirmData, setFuzzyListData, setPromptData, setPromptDateData, setReportData],
  );

  return {dialogs, onUIMessage};
}
